import React, { useMemo, useCallback } from 'react';
import { useQuery, useQueryClient} from 'react-query';
import { fetcher } from 'api/client';
import { useProfileAbility } from 'context/profile';

import ItemDetail from 'components/Shared/ItemDetail';
import {
    Milestones,
    Collaborators
} from './Contents'
import { fetchTemplate } from 'api/actions/templates';

const initialValues = {
    name: 'ContractName'
}

const tabs = [
    {
        name: 'milestones',
        icon: 'check',
        Component: Milestones,
        tooltip: ({ t }) => t('contracts.milestones.title'),
        shouldShow: ({ contract, profileAbility }) => {
            return true;
            // return profileAbility.can('read', 'Template', 'milestones');
        }
    },
    // { 
    //     name: 'collaborators', 
    //     icon: 'users', 
    //     Component: Collaborators ,
    //     tooltip: ({ t }) => t('contracts.collaborators.title'),
    //     shouldShow: ({ contract, profileAbility }) => {
    //         return true;
    //         // return profileAbility.can('read', 'Contract', 'collaboration');
    //     }
    // },
]


export default function TemplateDetail({ isOpen, toggle, initialContract = initialValues }) {
    const contractQueryId = useMemo(() => {
        return ['template', initialContract._id]
    }, [initialContract])
    const queryClient = useQueryClient();
    const ability = useProfileAbility()
    const { data, status } = useQuery(contractQueryId, ({ queryKey: [, templateId] }) => fetcher(fetchTemplate(templateId)), {
        enabled: !!initialContract._id,
        initialData: initialContract,
        staleTime: 5000
    })
    const refetch = useCallback(() => queryClient.invalidateQueries(contractQueryId), [contractQueryId])

    return (
        <ItemDetail
            isOpen={isOpen}
            title={data && data.name}
            onRefresh={refetch}
            onClose={toggle}
            tabs={tabs}
            defaultTab="timeline"
            isTemplate={true}
            contract={data}
            contractQueryId={contractQueryId}
            refetch={refetch}
            profileAbility={ability}
        />
    )
}